<template>
  <b-container fluid>
    <admin-preloader :show="loading"/>
    <b-row>
      <b-col sm="6">
        <admin-breadcrumb name="State Licenses"/>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <admin-panel with-footer>
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div class="d-flex align-items-end">
              <b-form-group label="Search" label-for="search-input" class="mr-2 mb-0" label-class="text-muted small mb-1">
                <b-form-input
                    id="search-input"
                    v-model="search"
                    size="sm"
                    placeholder="Search..."
                    style="width: 140px"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="License Type" label-for="license-prefix-filter" class="mr-2 mb-0" label-class="text-muted small mb-1">
                <b-form-select
                    id="license-prefix-filter"
                    v-model="license_prefix"
                    :options="licensePrefixOptions"
                    size="sm"
                    style="width: 130px"
                    @change="loadLicenses(1)"
                ></b-form-select>
              </b-form-group>
              <b-form-group label="Has Internal DBA" label-for="has-internal-dba-filter" class="mr-2 mb-0" label-class="text-muted small mb-1">
                <b-form-select
                    id="has-internal-dba-filter"
                    v-model="has_internal_dba"
                    :options="hasInternalDbaFilterOptions"
                    size="sm"
                    style="width: 100px"
                    @change="loadLicenses(1)"
                ></b-form-select>
              </b-form-group>
              <b-form-group label="On Greenlists" label-for="on-greenlists-filter" class="mr-2 mb-0" label-class="text-muted small mb-1">
                <b-form-select
                    id="on-greenlists-filter"
                    v-model="on_greenlists"
                    :options="onGreenlistsFilterOptions"
                    size="sm"
                    style="width: 100px"
                    @change="loadLicenses(1)"
                ></b-form-select>
              </b-form-group>
              <b-form-group label="Status" label-for="status-filter" class="mr-2 mb-0" label-class="text-muted small mb-1">
                <b-form-select
                    id="status-filter"
                    v-model="status"
                    :options="statusFilterOptions"
                    size="sm"
                    style="width: 160px"
                    @change="loadLicenses(1)"
                ></b-form-select>
              </b-form-group>
              <div style="padding-top: 1.65rem; padding-bottom: 0.25rem">
                <b-form-checkbox
                    id="show-placeholders-checkbox"
                    v-model="show_placeholders"
                    class="mb-0"
                    @change="loadLicenses(1)"
                >
                  Include Not Found
                </b-form-checkbox>
              </div>
            </div>
            <div>
              <no-permission-wrapper :show="!canCreateStateLicenses">
                <b-button variant="info" v-b-modal.dispatch-license-check-modal :disabled="!canCreateStateLicenses">Add/Refresh License</b-button>
              </no-permission-wrapper>
              <no-permission-wrapper :show="!canCreateStateLicenses">
                <b-button variant="primary" v-b-modal.create-license-modal :disabled="!canCreateStateLicenses">Create License</b-button>
              </no-permission-wrapper>
            </div>
          </div>
          <b-modal id="dispatch-license-check-modal" title="Add/Refresh License" @ok="dispatchLicenseCheck">
            <template #modal-footer="{ ok, cancel }">
              <b-button variant="secondary" @click="cancel()">Cancel</b-button>
              <b-button variant="primary" @click="ok()">Submit</b-button>
            </template>
            <p>Enter a license number to add or refresh from the MED database</p>
            <b-form @submit.stop.prevent="dispatchLicenseCheck">
              <b-form-group label-for="dispatch-license-number-input">
                <b-form-input id="dispatch-license-number-input" v-model="dispatchLicenseNumber" required></b-form-input>
              </b-form-group>
            </b-form>
          </b-modal>
          <b-modal id="create-license-modal" title="Create New State License" @ok="createLicense">
            <template #modal-footer="{ ok, cancel }">
              <b-button variant="secondary" @click="cancel()">Cancel</b-button>
              <b-button variant="primary" @click="ok()">Create</b-button>
            </template>
            <b-form @submit.stop.prevent="createLicense">
              <b-form-group label="License Number" label-for="new-license-number-input"><b-form-input id="new-license-number-input" v-model="newLicense.license_number" required></b-form-input></b-form-group>
              <b-form-group label="Facility Name" label-for="new-facility-name-input"><b-form-input id="new-facility-name-input" v-model="newLicense.facility_name" required></b-form-input></b-form-group>
              <b-form-group label="DBA Name" label-for="new-dba-name-input"><b-form-input id="new-dba-name-input" v-model="newLicense.dba_name"></b-form-input></b-form-group>
              <b-form-group label="Street" label-for="new-street-input"><b-form-input id="new-street-input" v-model="newLicense.street"></b-form-input></b-form-group>
              <b-form-group label="City" label-for="new-city-input"><b-form-input id="new-city-input" v-model="newLicense.city"></b-form-input></b-form-group>
              <b-form-group label="Zip Code" label-for="new-zip-code-input"><b-form-input id="new-zip-code-input" v-model="newLicense.zip_code"></b-form-input></b-form-group>
            </b-form>
          </b-modal>
          <admin-state-licenses-table
              :licenses="licenses"
              class="state-licenses-table"
              :sort-by="sortBy"
              :sort-desc="sortDesc"
              @sort-changed="onSortChanged"
          />
          <template v-slot:footer>
            <b-pagination
                v-model="page"
                :total-rows="total"
                :per-page="per_page"
                @change="loadLicenses"
                align="center"
                class="admin-pagination mb-0"
            />
          </template>
        </admin-panel>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import _ from 'lodash';
import AdminPanel from "../components/AdminPanel";
import {API_ROUTES} from "../api";
import AdminPreloader from "../components/AdminPreloader";
import AdminBreadcrumb from "../components/AdminBreadcrumb";
import AdminStateLicensesTable from "../components/AdminStateLicensesTable.vue";
import NoPermissionWrapper from "../components/NoPermissionWrapper.vue";

export default {
  name: "StateLicenses",
  components: {
    NoPermissionWrapper,
    AdminStateLicensesTable,
    AdminBreadcrumb,
    AdminPreloader,
    AdminPanel
  },
  data() {
    return {
      licenses: [],
      loading: true,
      page: 1,
      per_page: 100,
      total: 0,
      sortBy: 'shared_ownership_count',
      sortDesc: true,
      search: '',
      license_prefix: null,
      has_internal_dba: null,
      on_greenlists: null,
      status: null,
      show_placeholders: false,
      hasInternalDbaFilterOptions: [
        { value: null, text: 'All' },
        { value: true, text: 'With Internal DBA' },
        { value: false, text: 'Without Internal DBA' },
      ],
      onGreenlistsFilterOptions: [
        { value: null, text: 'All' },
        { value: 'on_greenlists', text: 'On Greenlists' },
        { value: 'not_on_greenlists', text: 'Not on Greenlists' },
      ],
      statusFilterOptions: [
        { value: null, text: 'All' },
        { value: 'Approved', text: 'Approved' },
        { value: 'Void', text: 'Void' },
        { value: 'Expired', text: 'Expired' },
        { value: 'Voluntary Surrender', text: 'Voluntary Surrender' },
        { value: 'Revoked', text: 'Revoked' },
        { value: 'Withdrawn', text: 'Withdrawn' },
        { value: 'Converted to Non-Resident AK', text: 'Converted to Non-Resident AK' },
        { value: 'Suspended', text: 'Suspended' },
        { value: 'Deceased', text: 'Deceased' },
        { value: 'Converted to Resident AK', text: 'Converted to Resident AK' },
        { value: 'Denied', text: 'Denied' },
        { value: 'Not Found', text: 'Not Found' },
      ],
      licensePrefixOptions: [
        { value: null, text: 'All Prefixes' },
        { value: '402-', text: '402' },
        { value: '402R-', text: '402R' },
        { value: '403-', text: '403' },
        { value: '403R-', text: '403R' },
        { value: '404-', text: '404' },
        { value: '404R-', text: '404R' },
        { value: '505-', text: '505' },
        { value: '605R-', text: '605R' }
      ],
      newLicense: {
        license_number: '',
        facility_name: '',
        dba_name: '',
        street: '',
        city: '',
        zip_code: ''
      },
      dispatchLicenseNumber: ''
    }
  },
  created() {
    const query = this.$route.query;
    this.page = parseInt(query.page, 10) || 1;
    this.sortBy = query.sort_by || 'shared_ownership_count';
    this.sortDesc = query.sort_desc ? query.sort_desc === 'true' : true;
    this.search = query.search || '';
    this.license_prefix = query.license_prefix || null;
    if (query.hasOwnProperty('has_internal_dba')) {
      this.has_internal_dba = JSON.parse(query.has_internal_dba);
    } else {
      this.has_internal_dba = null;
    }
    this.on_greenlists = query.on_greenlists || null;
    this.status = query.status || null;
    this.show_placeholders = query.show_placeholders === 'true';

    this.debouncedLoadLicenses = _.debounce(this.loadLicenses, 500);
    this.loadLicenses(this.page, false); // Don't update router on initial load
  },
  watch: {
    search(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.debouncedLoadLicenses(1);
      }
    }
  },
  methods: {
    updateRouterQuery() {
      const query = {};
      if (this.page > 1) query.page = this.page;
      if (this.sortBy !== 'shared_ownership_count') query.sort_by = this.sortBy;
      if (this.sortDesc !== true) query.sort_desc = this.sortDesc;
      if (this.search) query.search = this.search;
      if (this.license_prefix) query.license_prefix = this.license_prefix;
      if (this.has_internal_dba !== null) query.has_internal_dba = this.has_internal_dba;
      if (this.on_greenlists) query.on_greenlists = this.on_greenlists;
      if (this.status) query.status = this.status;
      if (this.show_placeholders) query.show_placeholders = 'true';

      if (!_.isEqual(this.$route.query, query)) {
        this.$router.replace({ query }).catch(()=>{});
      }
    },
    loadLicenses(page = 1, updateRouter = true) {
      if (page !== this.page) {
        this.page = page;
      }
      if (updateRouter) {
        this.updateRouterQuery();
      }
      this.loading = true;
      let params = {
        page: page,
        per_page: this.per_page,
        sort_by: this.sortBy,
        sort_desc: this.sortDesc,
        license_prefix: this.license_prefix,
      };
      if (this.search) {
        params['search'] = this.search;
      }
      if (this.has_internal_dba !== null) {
        params['has_internal_dba'] = this.has_internal_dba;
      }
      if (this.on_greenlists) {
        params['on_greenlists'] = this.on_greenlists;
      }
      if (this.status) {
        params['status'] = this.status;
      }
      if (this.show_placeholders) {
        params['show_placeholders'] = true;
      }
      this.$api.get(API_ROUTES.ADMIN_STATE_LICENSES, {
        params: params
      }).then(({data}) => {
        this.licenses = data.result.data;
        this.total = data.result.total;
        this.per_page = data.result.per_page;
      }).catch((error) => {
        const message = error.response?.data?.message || 'Error loading licenses';
        this.$bvToast.toast(message, {
          variant: 'danger',
          title: 'Error!'
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    onSortChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.loadLicenses(1);
    },
    createLicense(bvModalEvt) {
      bvModalEvt.preventDefault();

      if (!this.canCreateStateLicenses) {
        return this.$bvToast.toast('You do not have permission to create state licenses.', {
          variant: 'danger',
          title: 'Error!'
        });
      }

      if (!this.newLicense.license_number) {
        this.$bvToast.toast('License number is required.', {
          variant: 'danger',
          title: 'Error!'
        });
        return;
      }
      if (!this.newLicense.facility_name) {
        this.$bvToast.toast('Facility name is required.', {
          variant: 'danger',
          title: 'Error!'
        });
        return;
      }

      this.$api.post(API_ROUTES.ADMIN_STATE_LICENSES, this.newLicense)
        .then(() => {
          this.$bvToast.toast('State license created successfully!', {
            variant: 'success',
            title: 'Success!'
          });
          this.$root.$emit('bv::hide::modal', 'create-license-modal');
          this.newLicense = {
            license_number: '',
            facility_name: '',
            dba_name: '',
            street: '',
            city: '',
            zip_code: ''
          };
          this.loadLicenses(1);
        })
        .catch(error => {
          const message = error.response?.data?.message || 'Error creating state license';
          this.$bvToast.toast(message, {
            variant: 'danger',
            title: 'Error!'
          });
        });
    },
    dispatchLicenseCheck(bvModalEvt) {
      bvModalEvt.preventDefault();

      if (!this.canCreateStateLicenses) {
        return this.$bvToast.toast('You do not have permission to create state licenses.', {
          variant: 'danger',
          title: 'Error!'
        });
      }

      if (!this.dispatchLicenseNumber) {
        this.$bvToast.toast('License number is required.', {
          variant: 'danger',
          title: 'Error!'
        });
        return;
      }

      this.$api.post(`${API_ROUTES.ADMIN_STATE_LICENSES}/dispatch/${this.dispatchLicenseNumber}`)
          .then(() => {
            this.$bvToast.toast('License check dispatched successfully!', {
              variant: 'success',
              title: 'Success!'
            });
            this.dispatchLicenseNumber = '';
            this.$root.$emit('bv::hide::modal', 'dispatch-license-check-modal');
          })
          .catch(error => {
            const message = error.response?.data?.message || 'Error dispatching license check';
            this.$bvToast.toast(message, {
              variant: 'danger',
              title: 'Error!'
            });
          });
    }
  },
  computed: {
    canCreateStateLicenses() {
      return this.$store.getters['auth/hasAdminPermissions']('state_license_create');
    }
  }
}
</script>

<style scoped>
.state-licenses-table {
  font-size: 12px;
}
</style>
